import { render, staticRenderFns } from "./UDIruku.vue?vue&type=template&id=f5898ae0&scoped=true"
import script from "./UDIruku.vue?vue&type=script&lang=js"
export * from "./UDIruku.vue?vue&type=script&lang=js"
import style0 from "./UDIruku.vue?vue&type=style&index=0&id=f5898ae0&prod&scoped=true&lang=css"
import style1 from "./UDIruku.vue?vue&type=style&index=1&id=f5898ae0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5898ae0",
  null
  
)

export default component.exports